import styled from 'styled-components'

export const EmbedContainer = styled.div`
  display: flex;
  width: 100%;
  position: absolute;
  top: 8%;
  bottom: 0;
`
